import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import RadioButton from '@wix/da-a11y/pkg/components/formControls/RadioButton';
import { useFacet } from '../../common';
import FacetContent from '../../lego/FacetContent';
const FacetRadioButton = (props)=>{
    const { rootProps, contentProps } = useFacet(props);
    return /*#__PURE__*/ React.createElement(RadioButton, _object_spread({
        // FacetContent has a required `children: string` type on it, so that forces the consumer to provide the necessary text
        hasAccessibleText: true,
        checked: !!props.selected
    }, rootProps), /*#__PURE__*/ React.createElement(FacetContent, contentProps));
};
FacetRadioButton.displayName = 'FacetRadioButton';
export default FacetRadioButton;
